







































import Vue, {
    PropType,
} from 'vue';

// Validations
import {
    runValidations,
    Validation,
} from '@shared/validations';

export default Vue.extend({
    name: 'custom-input',
    props: {
        label: {
            type: String,
            required: true,
        },
        name: {
            type: String,
            required: true,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        hint: {
            type: String,
            default: '',
        },
        hideHint: {
            type: Boolean,
            default: false,
        },
        type: {
            type: String,
            default: 'text',
        },
        value: {
            type: [String, Number],
            default: '',
        },
        placeholder: {
            type: String,
            default: '',
        },
        maxLengthCounter: {
            type: Number,
            default: -1,
        },
        loading: {
            type: Boolean,
            default: false,
        },
        errorMessage: {
            type: String,
            default: '',
        },
        validations: {
            type: Array as PropType<Array<Validation>>,
            default: () => [],
        },
        validateOnMount: {
            type: Boolean,
            default: false,
        },
        validateOnBlur: {
            type: Boolean,
            default: false,
        },
        required: {
            type: Boolean,
            default: false,
        },
        isValid: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
            validationErrorMessage: '',
            avoidNextValidation: false,
        };
    },
    computed: {
        showCounter() {
            return this.maxLengthCounter > -1;
        },
        labelClass() {
            return [
                'label custom-input__label', {
                    'label--disabled': this.disabled,
                },
            ];
        },
        inputClass() {
            return [
                'label__input custom-input__input', {
                    'label__input--active': this.value,
                    'input--disabled': this.disabled,
                    'input--loading': this.loading,
                },
            ];
        },
        characterCounterClass() {
            return [
                'character-counter', {
                    'character-counter--disabled': this.value.length === 0,
                    'character-counter--error': this.value.length > this.maxLengthCounter,
                },
            ];
        },
        characterCounterText() {
            return `${this.value.length} / ${this.maxLengthCounter}`;
        },
        hintClass() {
            return [
                'custom-input__hint', {
                    'custom-input__error': this.errorMessage || this.validationErrorMessage,
                },
            ];
        },
    },
    mounted() {
        if (this.validateOnMount) {
            this.validate();
        }
    },
    methods: {
        handleInputChange(event) {
            this.$emit('input', event.target.value);

            if (this.avoidNextValidation) {
                this.avoidNextValidation = false;

                return;
            }

            this.$nextTick(() => {
                if (!this.validateOnBlur) {
                    this.validate();
                }
            });
        },

        validate() {
            if (!this.value && this.required) {
                this.validationErrorMessage = this.$t('errors.requiredField');
            } else {
                this.validationErrorMessage = runValidations(this.validations, this.value);
            }

            this.$emit('update:isValid', Boolean(!this.validationErrorMessage && !this.errorMessage));
        },

        onBlur() {
            if (this.validateOnBlur) {
                this.validate();
            }
        },

        reset() {
            if (this.value) {
                this.avoidNextValidation = true;
                this.$emit('input', '');
            }

            this.validationErrorMessage = '';
            this.$emit('update:isValid', !this.required);
        },

    },
});
